module.exports = __webpack_public_path__ + "img/Logo 2.522318e1.png";